import React from "react"
import { AntSwitchSeeker } from "@ui-seeker/core"


export default function AppAntSwitch({ falseText = null, ...props }) {
	return <AntSwitchSeeker
		falseText={falseText}
		formControlProps={{
			sx: { width: 45 },
		}}
		sx={{
			left: -11,
			width: 65,
			".Mui-checked": {
				right: 10
			},
			...props.switchProps
		}}
		falseProps={{
			sx: {
				...!falseText && { display: 'none' },
				fontWeight: 'bold',
				mr: "8px !important",
				...props.falseProps
			}
		}}
		trueProps={{
			sx: {
				fontWeight: 'bold',
				ml: 2,
				...props.trueProps
			}
		}}
		{...props}
	/>
}